import router from './index'
import ElementUI, {
    Message
} from 'element-ui'
import {getToken} from "../utils/auth";
// import {getToken, removeToken} from "../utils/auth";
// import store from "../store";
// const whiteList = ['/login','/404','/autologin'];


// 路由拦截器
// router.beforeEach(async (to, from, next) => {
//   const hasToken = getToken();
//   if(hasToken){//用户已登录
//     if(to.path === '/login'){
//       next({path:'/'});
//     } else {
//       const user = store.getters.user;
//       if(user){
//         // const accessRoutes = [];//根据角色获取动态路由，页面菜单
//         next();
//       }else{
//         removeToken();
//         next({path:'/login',replace:true});
//       }
//     }
//   }else{
//     if(whiteList.indexOf(to.path) !== -1){
//       //白名单路由，允许访问
//       next();
//     }else{
//       //未登录而企图访问其他页面，强制跳转到登录页面
//       next({path:'/login',replace:true});
//     }
//   }
// });

router.beforeEach((to, from, next) => {
    // if (to.path === '/login') return next();
    //获取token
    const tokenStr = window.sessionStorage.getItem('token')
    if (!getToken()) {
        console.log('no token', to.path);
        if (to.path == '/login') return next()
        Message.warning("登陆状态过期，请重新登陆")
        // if (to.path == '/login') return next()
        if (to.path == '/home') return next('login')

        return next('/login')
    }

    localStorage.setItem('activeMenu', to.path);

    next()
})



// WEBPACK FOOTER //
// ./src/router/permission.js